import { VendorRebateCategoryDetail } from '../../../components/Vendor/RebateCategories/VendorRebateCategoryDetail';

export function RebateCategory() {
  return <VendorRebateCategoryDetail />;
}
